import { Examples } from '@/types';

export const ExampleErrorsRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleErrors,
        components: {
          default: () => import(/* webpackChunkName: "ExampleErrors" */ '@/views/examples/ExampleErrors.vue')
        }
      },
      {
        ...Examples.ExampleWithErrorPage,
        components: {
          default: () => import(/* webpackChunkName: "ExampleErrors" */ '@/views/examples/ExampleErrors.vue')
        }
      }
    ]
    : [];
